import {migrateConversations} from "./utils"

async function migrateAllConversations(collection) {
    const tickets = await collection.find({}).toArray()

    const operations = tickets
        .map(ticket => {
            const set = {}
            migrateConversations(ticket, set)
            return {_id: ticket._id, set}
        })
        .filter(({set}) => Object.keys(set).length)
        .map(({_id, set}) => ({
            updateOne: {filter: {_id}, update: {$set: set}}
        }))

    if (!operations.length) return 0

    const result = await collection.bulkWrite(operations)
    return result.modifiedCount
}

async function applyJob() {
    const collection = global.app.R.Ticket.collection

    const conversationsUpdated = await migrateAllConversations(collection)

    return {message: `${conversationsUpdated} conversation(s) adaptée(s)`}
}

export const job = {
    name: "adaptTicketCollection",
    title: "Adapter la collection Ticket au nouveau modèle",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}